import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';

const RDCard = ({ cardSize, cardTitle, cardHeadStyle, children, cardBodyStyle }) => (
  <Card title={cardTitle} size={cardSize} headStyle={cardHeadStyle} bodyStyle={cardBodyStyle}>
    {children}
  </Card>
);

RDCard.defaultProps = {
  cardSize: 'small',
  cardHeadStyle: {},
  cardBodyStyle: {},
  cardTitle: '',
};

RDCard.propTypes = {
  /** Size of card - default | small	  */
  cardSize: PropTypes.string,
  /** Card title */
  cardTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Inline style to apply to the card head */
  cardHeadStyle: PropTypes.shape({}),
  /** Inline style to apply to the card content */
  cardBodyStyle: PropTypes.shape({}),
  /** Card content */
  children: PropTypes.element.isRequired,
};

export default RDCard;
